import React from 'react'
import { Typography } from '@mui/material'

const MainToolbarUser = (props) => {
  return (
    <Typography variant="h6" noWrap style={{ marginRight: 15 }}>{`${props.userInfo.username} (${props.userInfo.role})`}</Typography>
  )
}

export default MainToolbarUser
